import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Second Eddy",
  "description": "",
  "published": "2007-06-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-second-eddy/swizec/190"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Edward the Second is an old play, a very old one indeed, written by Christopher Marlowe back in the Elizabethan times of early modern English, corsets and dirt, a lot of dirt. The play has been reinterpreted many a time, one of those being by the local playhouse.`}</p>
    <p>{`I have no idea how long it's been in their repertoir, but I went to see it last Friday. For free. Yes, the lovely gents and ladies of the playhouse gave two free tickets to a choice of one of four plays to whomever was in posession of a season ticket. I was one of them and chose Edward the Second because it was the least known to me.`}</p>
    <p>{`The playhouse was, unsurprisingly, packed full with only two empty seats known to me, luckily in such a position I could shift my arse to them and get a better view. Something should really be done about visibility in that 100 year old building ... Anyway, the play was reasonably long and very fun to watch. THe actors did a spectacular job of interpreting such an old piece and even the scarcety of the scenography brought out that elizabethan theater flavour. It felt right, even though seeing the very back wall of the stage for the first time was a bit boring.`}</p>
    <p>{`When the lead actor took off all his clothing I was taken by surprise because I didn't think anyone would put nudity in a play of such oldness, because it would not be done back then I don't think. When he went into convulsions and his equipment jumped around ... it was a bit odd to say the least. But c'est la vie, that's modern theater for you, nudity galore.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      